import React from 'react';
import StaticPage, { Section } from './StaticPage';

export default function CommunityGuidelines() {
  return (
    <StaticPage title="Community Guidelines" subtitle="Rules and standards that keep RentalX safe and respectful for everyone.">
      <Section title="Our Community Values">
        <p>RentalX is built on trust, respect, and transparency. Whether you're a student searching for a home or a landlord listing a property, these guidelines apply to everyone on our platform.</p>
      </Section>

      <Section title="For All Users">
        <ul className="list-disc list-inside space-y-2">
          <li><strong>Be honest</strong> — Provide accurate information in your profile, listings, and messages</li>
          <li><strong>Be respectful</strong> — Treat others with courtesy regardless of background or nationality</li>
          <li><strong>No discrimination</strong> — Listings and tenancy decisions must comply with Australia's anti-discrimination laws</li>
          <li><strong>No harassment</strong> — Abusive, threatening, or inappropriate communication will result in account suspension</li>
          <li><strong>Protect privacy</strong> — Do not share another user's personal information without consent</li>
          <li><strong>Report problems</strong> — If you see something suspicious or inappropriate, report it immediately</li>
        </ul>
      </Section>

      <Section title="For Landlords">
        <ul className="list-disc list-inside space-y-2">
          <li>Listings must accurately represent the property (photos, description, price, availability)</li>
          <li>All pricing must be in AUD and clearly state what is included (utilities, WiFi, etc.)</li>
          <li>Landlords must have legal right to rent the property</li>
          <li>Bond must be handled in accordance with state law</li>
          <li>Respond to student enquiries within 48 hours to maintain your response rate</li>
          <li>No listing of the same property multiple times at different prices</li>
        </ul>
      </Section>

      <Section title="For Students">
        <ul className="list-disc list-inside space-y-2">
          <li>Only make genuine enquiries for accommodation you are seriously considering</li>
          <li>Honour viewing appointments — notify landlords if you need to cancel</li>
          <li>Leave honest, factual reviews based on your actual experience</li>
          <li>Treat rental properties with care and respect</li>
        </ul>
      </Section>

      <Section title="Violations">
        <p>Violations of these guidelines may result in content removal, account suspension, or permanent bans. Serious violations including fraud, misrepresentation, or illegal activity will be referred to relevant authorities.</p>
        <p className="mt-2">Report violations to <strong>community@rentalx.com.au</strong>.</p>
      </Section>
    </StaticPage>
  );
}
